import BaseService from './baseService';

export default class TenantsAddressesService extends BaseService {
  static instance = null;

  static getInstance(store) {
    if (!TenantsAddressesService.instance) {
      TenantsAddressesService.instance = new TenantsAddressesService(store);
    }
    return TenantsAddressesService.instance;
  }

  constructor(store) {
    const baseUrl = process.env.API_PATH;
    super(store, baseUrl, 'tenants', 'tenant');
  }

  addItem(tenantId, obj, lang, token, okCallBack, koCallBack) {
    return super.post(this.itemName, `${this.urlPath}/${tenantId}/addresses`, lang, token, obj, okCallBack, koCallBack);
  }

  updateItem(tenantId, obj, lang, token, okCallBack, koCallBack) {
    return super.put(this.itemName, `${this.urlPath}/${tenantId}/addresses/${obj.id}`, lang, token, obj, okCallBack);
  }

  deleteItem(tenantId, addressId, lang, token, okCallBack, koCallBack) {
    return super.delete(this.itemName, `${this.urlPath}/${tenantId}/addresses/${addressId}`, lang, token, okCallBack);
  }
}